import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext, getIn } from 'formik';
import { lookupsJson } from '@ourbranch/lookups';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from 'common/components/farm/locations/risks/sub-risks/sub-risk-collapsible-section';
import useStyles from '../liability-coverages-styles';

const manMonthsOptions = lookupsJson.farm.manMonthsOptions;

const FIELD_NAME = 'farmLiabilityCoverage.numManMonths';

const EmployersLiability = ({ disabled = false, onChangeActive }) => {
  const classes = useStyles();
  const { values } = useFormikContext();

  const currentValue = getIn(values, FIELD_NAME) || 0;

  return (
    <div className={classes.sectionContainer}>
      <SubRiskCollapsibleSection
        type="secondary"
        content={<div className={classes.headerText}>Employer's liability for farm employees</div>}
        initialOpen={currentValue > 0}
      >
        <Field
          xs={12}
          type="select"
          id={FIELD_NAME}
          name={FIELD_NAME}
          mode="dark"
          label="Total man months (per year)"
          options={manMonthsOptions}
          disabled={disabled}
          onChange={onChangeActive}
        />
      </SubRiskCollapsibleSection>
    </div>
  );
};

EmployersLiability.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChangeActive: PropTypes.func.isRequired
};

export default EmployersLiability;
